import {useResource} from './baseHooks';
import {fetchLeavesInYearMonth, Leave} from "../api/LeaveApi";
import {useCallback} from "react";

export const useLeaves = (year: number, month: number) => {

    const loadLeaves = useCallback(async (): Promise<Leave[]> => {
        const response = await fetchLeavesInYearMonth(year, month);
        return response.data || [];
    }, [year, month]);

    const {
        data: leaves,
        loading: loadingLeaves,
        error,
        reload: reloadLeaves
    } = useResource(loadLeaves, { defaultValue: [] as Leave[] });

    return { leaves, loadingLeaves, error, reloadLeaves };
};

export default useLeaves;